import React, { useEffect, useState, useCallback } from "react";
import Menu from "./Menu/Menu";
import useSize from "../../../Utils/useSize/useSize";
import Backend from "../../../Backend/Backend";
import toast from "react-hot-toast";
import Loading from "../../../Utils/Loading/Loading";
import useSound from "use-sound";
import ErrorSoundFile from "../../../Sound/Error.wav";
import NotFound from "../../../Utils/NotFound/NotFound";
import SymbolCard from "./SymbolCard";
import moment from "moment";
import Filter from "./Filter/Filter";

const backend = await new Backend().init();

export default function SymbolLogs({ user_id }) {
  const [play] = useSound(ErrorSoundFile);
  const windowSize = useSize();

  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const height = windowSize[1] - 260;
  const width = windowSize[0] - 100;

  /** -----------------------------------------
   * LOAD LOGS (Memoized)
   ------------------------------------------ */
  const loadLogs = useCallback((start, end) => {
    setLoading(true);

    const data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      user_id : user_id,
      start: start ?? moment().startOf("week").format("YYYY-MM-DD HH:mm:ss"),
      end: end ?? moment().endOf("week").format("YYYY-MM-DD HH:mm:ss"),
    };

    backend.symbol_rejection(data).then((r) => {
      setLoading(false);
      if (r.error === "False") {
        setLogs(r.rejection);
      } else {
        play();
        toast.error(r.message);
      }
    });
  }, [play]);

  /** Load initial logs */
  useEffect(() => {
    loadLogs();
  }, [loadLogs]);

  return (
    <div style={{ width: width, height: windowSize[1] - 170 }}>
      <Filter records={logs.length} loadLogs={loadLogs} logs={logs} />
      <Menu />

      {/* LIST AREA */}
      <div className="flex flex-col" style={{ height, width }}>
        {loading ? (
          <div className="loadingContainer">
            <Loading height={height} />
          </div>
        ) : logs.length > 0 ? (
          <div className="overflow-y-scroll" style={{ height, width }}>
            {logs.map((item) => (
              <SymbolCard key={item.id} item={item} />
            ))}
          </div>
        ) : (
          <NotFound
            height={height}
            title="Nothing here"
            subtext="No Symbol Logs Found."
          />
        )}
      </div>
    </div>
  );
}
